import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import image from "../../asset/imgs/404.png";
import { Box, Typography } from "@mui/material";

function NotFound() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const path = useLocation().pathname;
  useEffect(() => {
    if (path == "/") return;
    const timer = setTimeout(() => {
      navigate("/dashboard/overview", { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (path == "/") return null;
  return (
    <Box>
      {token !== null && (
        <Box
          sx={{
            textAlign: "center",
            mt: { xs: 2, md: 4 },
            px: { xs: 1, md: 0 },
          }}
        >
          <Box
            component="img"
            src={image}
            alt="404-page"
            sx={{
              width: { xs: "100%", sm: "70%", md: "20rem" },
              maxWidth: "100%",
              height: { xs: "auto", md: "auto" },
              mb: 2,
            }}
          />

          <Typography
            variant="h4"
            component="h4"
            sx={{ fontSize: { xs: "1.2rem", md: "2rem" } }}
          >
            صفحه مورد نظر یافت نشد
          </Typography>
          <Typography
            variant="h6"
            component="h6"
            sx={{
              fontSize: { xs: "0.9rem", md: "1.2rem" },
              mt: 1,
            }}
          >
            در حال انتقال به داشبورد...
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default NotFound;
